<template>
  <div>
    <div class="left_list">
      <div class="left_list_title left_list_title2">
        <span>特色商铺分布</span>
      </div>
      <div class="list_main_wrapper">
        <div class="item_pic">
          <div
            :class="'item_type' + (index + 1)"
            v-for="(ietm, index) in dataList"
            :key="index"
          >
            <div :class="'item_type' + (index + 1) + '_txt'">
              {{ ietm.label }}
            </div>
            <div :class="'item_type' + (index + 1) + '_number'">
              {{ ietm.value }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "@/assets/js/swiper.min.js";
import * as echarts from "echarts";

export default {
  data() {
    return {
      dataList: [
        { label: "特色小吃类", value: 15 },
        { label: "老字号店铺", value: 19 },
        { label: "特色伴手礼", value: 37 },
        { label: "特色干货类", value: 23 },
        { label: "特色民宿", value: 6 },
      ],
    };
  },
  props: {
    special_shop_distribution: {
      typeof: Array,
      default: () => [],
    },
  },
  watch: {
    special_shop_distribution: {
      deep: true,
      handler: function (newV, oldV) {
        this.getData(); //注释掉
      },
    },
  },
  mounted() {},
  created() {},
  methods: {
    getData() {
      console.log();
      for (let index = 0; index < 5; index++) {
        const e = this.special_shop_distribution[index];
        this.dataList[index].name = e.labnameel;
        this.dataList[index].value = e.value;
      }
    },
  },
};
</script>
<style scoped src="@/assets/css/index3.css">
</style>